// Auto-generated by scripts/sync-version.js — do not edit manually.
export const NEAT_VERSION = "1.1.0";
